import Vue from 'vue'
import app from '@/main'

const listBusinessRulesModule = {
  namespaced: true,
  state: {
    rules: [],
    searchRuleValue: ''
  },

  mutations: {
    setRules: (state, rules) => (state.rules = rules),
    setSearchRuleValue: (state, value) => (state.searchRuleValue = value)
  },

  getters: {
    getBusinessRules: (state) => {
      let result = state.rules.map((rule) => {
        rule.edit_url = `/#/instruments/list_business_rules/edit_rule/${rule.id}`
        return rule
      })

      if (!state.searchRuleValue) {
        return result
      }

      return result.filter((rule) =>
        rule.name.toLowerCase().includes(state.searchRuleValue.toLowerCase())
      )
    }
  },

  actions: {
    GET_BUSINESS_RULES: async ({ commit, rootGetters }) => {
      try {
        const response = await Vue.http.get(
          `${rootGetters.getBackendUrl}/recommendations/business_rules/list`,
          {
            headers: rootGetters.getAllResponseHeaders
          }
        )

        if (response.ok) {
          commit('setRules', response.body.rules)
        }
      } catch (e) {
        app.$raven.captureException(e)
      }
    }
  }
}

export default listBusinessRulesModule



// WEBPACK FOOTER //
// ./src/store/modules/recommendations/modules/list_business_rules.js